import AllWebSites from '@/views/dashboard/allwebsites.vue'
import Dashboard from '@/views/dashboard/dashboard.vue'
import WebSiteNE from '@/views/pages/measurables/website_ne.vue'

export default [
  {
    path: '/all-web-sites',
    name: 'all-web-sites',
    component: AllWebSites
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard
  },
  {
    path: '/all-web-sites/website/:cmd',
    name: 'web-site',
    component: WebSiteNE
  }
]
